import React, { useState, useEffect, useRef } from "react";

import validator from "validator";

export const required = (value) => {
  if (!value || value == "") {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

export const emailvalid = (value) => {
  if (!validator.isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} is not a valid email.`}
      </div>
    );
  }
};

export const phonevalid = (value) => {
  var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (!value.match(phoneno)) {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} is not a valid Phone Number.`}
      </div>
    );
  }
};

export const pincodevalid = (value) => {
  var data = /^([0-9]{4}|[0-9]{6})$/;
  if (!value.match(data)) {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} is not a valid pincode.`}
      </div>
    );
  }
};

export const profilevalid = (value) => {
  console.log("mydata", value.split(".")[1]);
  const ext = value.split(".")[1];

  if (ext != "jpg" || ext != "jpeg" || ext != "png") {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} only jpg.`}
      </div>
    );
  }
};

export const websitevalid = (value) => {
  var url =
    /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
  if (!value.match(url)) {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} is not a valid website.`}
      </div>
    );
  }
};

export const integervalid = (value) => {
  var data = /^([+-]?[1-9]\d*|0)$/;
  if (!value.match(data)) {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} is only integer value.`}
      </div>
    );
  }
};

export const stringvalid = (value) => {
  var data = /^[a-zA-Z_ ]*$/;
  if (!value.match(data)) {
    return (
      <div className="alert alert-danger" role="alert">
        {`${value} is only string value.`}
      </div>
    );
  }
};

export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return (
      <span className="error">
        The value exceeded {props.maxLength} symbols.
      </span>
    );
  }
};
